import { Button, Card, Col, Form, InputNumber, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addNoticePeriod, deleteNoticePeriod, getAllNoticePeriod, updateNoticePeriod } from '../../redux/rtk/features/masters/noticePeriodSlice';
import PageTitle from '../page-header/PageHeader';

const NoticePeriodMaster = () => {
  const { Title } = Typography;

  const [editingNoticePeriod, setEditingNoticePeriod] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.noticePeriod);

  useEffect(() => {
    dispatch(getAllNoticePeriod());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingNoticePeriod) {
        // Update existing noticePeriod
        const result = await dispatch(
          updateNoticePeriod({ id: editingNoticePeriod.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllNoticePeriod());
        } else {
          message.error('Error updating notice period!');
        }
      } else {
        // Add new noticePeriod
        const result = await dispatch(addNoticePeriod(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllNoticePeriod());
        } else {
          message.error('Error adding notice period!');
        }
      }
      setEditingNoticePeriod(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update notice period!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteNoticePeriod(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllNoticePeriod()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Notice Period',
      dataIndex: 'noticePeriod',
      key: 'noticePeriod',
      render: (text) => `${text} Days`,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingNoticePeriod(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this notice period?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingNoticePeriod ? 'Edit Notice Period' : 'Add Notice Period'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="category-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="noticePeriod"
                label="Notice Period "
                rules={[{ required: true, message: 'Please enter a notice period!' }]}
              >
                <InputNumber placeholder="Enter notice period" />
              </Form.Item>

              <Button type="primary" block htmlType="submit">
                {editingNoticePeriod ? 'Update Notice Period' : 'Add Notice Period'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Notice Period List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default NoticePeriodMaster;
